import React from 'react'
import { Link } from 'react-router-dom'
export const accessdenied = () => {
  return (
    <>
      <div className='container'>
        <div className='d-flex align-items-center justify-content-center flex-column min-h-300 w-100'>
          <h2 className='AccessdeniedH2 font-16' tabIndex={0} aria-label="Sorry, this page hasn't been shared with you.">Sorry, this page hasn&apos;t been shared with you.</h2>
          <Link className="btn" to="/" state={{ refreshKey: Date.now() }}>&lt;&lt; Back to Home</Link>
        </div>
      </div>
    </>
  )
}
export default accessdenied
